import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Causale, SearchResult} from "../_models/_Index";
import {environment} from '../../environments/environment';
import {firstValueFrom} from 'rxjs';

@Injectable({providedIn: 'root'})
export class CausaliService {

  constructor(private http: HttpClient) {}

  async getCausaliFilteredAsync(orgId: number, search: string, page: number, count: number, sortField: string, sortAsc: boolean) {
    return firstValueFrom(this.http.post<SearchResult<Causale>>(`${environment.localApiUrl}api/Causali/CausaliFiltered?orgId=${orgId}`,
      {search, page, count, sortField, sortAsc}));
  }

  async getCausaleAsync(orgId: number, code: string) {
    return firstValueFrom(this.http.get<Causale>(`${environment.localApiUrl}api/Causali/Causale?orgId=${orgId}&code=${code}`));
  }

  async createCausaleAsync(causale: Causale) {
    return firstValueFrom(this.http.post<Causale>(`${environment.localApiUrl}api/Causali/CreateCausale`, causale));
  }

  async updateCausaleAsync(causale: Causale) {
    return firstValueFrom(this.http.post<Causale>(`${environment.localApiUrl}api/Causali/UpdateCausale`, causale));
  }

  async deleteCausaleAsync(orgId: number, code: string) {
    return firstValueFrom(this.http.get<Causale>(`${environment.localApiUrl}api/Causali/DeleteCausale?orgId=${orgId}&code=${code}`));
  }
}
